import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../services/api';
import PainSelectorDrawer from './PainSelectorDrawer';
import ActivitySelectorDrawer from './ActivitySelectorDrawer';
import NoteSelector from './NoteSelector';

function DiaryEntryWrapper({ user, toast }) {
    const { id } = useParams();
    const [attributes, setAttributes] = useState([])
    const [notes, setNotes] = useState("")
    const [activityLevel, setActivityLevel] = useState(0)
    const [currentStep, setCurrentStep] = useState(1)
    const [totalSteps, setTotalSteps] = useState(0)
    const [loaded, setLoaded] = useState(false)
    const [saving, setSaving] = useState(false)
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            navigate('/diary');
        }
    }, [navigate]);

    useEffect(() => {
        api.getDiary(user.id).then(data => {
            setAttributes(data.attributes.map(att => {
                return {
                    ...att,
                    value: 0
                }
            }))
            if (id) {
                const activeEntry = data.entries.find(entry => entry.id == id)
                setAttributes(activeEntry.attributes)
                setActivityLevel(activeEntry.activityLevel)
                setNotes(activeEntry.notes)
                if (!activeEntry) {
                    return navigate("/diary")
                }
            }
            setTotalSteps(data.attributes.length + 2)
            setLoaded(true)
        })
    }, [])

    const onContinue = () => {
        if (currentStep === totalSteps) {
            setSaving(true)
            api.saveDiaryEntry({
                attributes,
                notes,
                activityLevel,
                id: Number(id)
            })
                .then(() => {
                    if (id) {
                        toast("Entry Edited")
                    } else {
                        toast("Entry Created")
                    }
                    navigate('/diary')
                })
        } else {
            setCurrentStep(prevStep => prevStep + 1)
        }
    }
    const handleCancel = () => {
        navigate('/diary')
    }
    const setAttribute = newVal => {
        setAttributes(prev => {
            const temp = [...prev]
            temp[currentStep - 1].value = newVal
            return temp
        })
    }

    const onBack = () => {
        setCurrentStep(prev => prev - 1)
    }
    return (
        <div className="form-container">
            {(loaded && currentStep <= attributes.length) && (
                <PainSelectorDrawer
                    onContinue={onContinue}
                    currentStep={currentStep}
                    totalSteps={totalSteps}
                    onCancel={handleCancel}
                    attribute={attributes[currentStep - 1]}
                    setAttribute={setAttribute}
                    onBack={onBack}
                    isEdit={!!id}
                />
            )}
            {(loaded && currentStep === attributes.length + 1) && (
                <ActivitySelectorDrawer
                    onContinue={onContinue}
                    currentStep={currentStep}
                    totalSteps={totalSteps}
                    onCancel={handleCancel}
                    activityLevel={activityLevel}
                    setActivityLevel={setActivityLevel}
                    onBack={onBack}
                    isEdit={!!id}
                />
            )}
            {(loaded && currentStep === attributes.length + 2) && (
                <NoteSelector
                    onContinue={onContinue}
                    currentStep={currentStep}
                    totalSteps={totalSteps}
                    onCancel={handleCancel}
                    notes={notes}
                    setNotes={setNotes}
                    onBack={onBack}
                    submitting={saving}
                    isEdit={!!id}
                />
            )}
        </div>
    )
}

export default DiaryEntryWrapper;